import React from 'react';
import AccessPolicyNextGenBaseEditorModal from './AccessPolicyNextGenBaseEditorModal';
import {ACCESS_POLICY_OUTGOING} from '../../EditorPages/AbstractObjects/GatewayPlan/InnerPages/BaseAccessPolicy/util';

function AccessPolicyNextGenOutgoingEditorModal({
                                                    baseObjectName,
                                                    isOpen = false,
                                                    width = 710,
                                                    height = 720,
                                                    onCancel,
                                                    onSuccess,
                                                    defaultObject,
                                                    objectType,
                                                    appiData,
                                                    uoTableData,
                                                    zonesData,
                                                    setAppiDataValue,
                                                    setUoTableDataValue,
                                                }) {


    return (
        <>
            <AccessPolicyNextGenBaseEditorModal
                baseObjectName={baseObjectName}
                isOpen={isOpen}
                width={width}
                height={height}
                onCancel={onCancel}
                onSuccess={onSuccess}
                defaultObject={defaultObject}
                objectType={objectType}
                appiData={appiData}
                uoTableData={uoTableData}
                zonesData={zonesData}
                incomingOrOutgoing={ACCESS_POLICY_OUTGOING}
                setAppiDataValue={setAppiDataValue}
                setUoTableDataValue={setUoTableDataValue}
            />
        </>
    );
}

export default AccessPolicyNextGenOutgoingEditorModal;